import { NavbarMenu } from '@/partials/menu/NavbarMenu';

interface PageMenuProps {
  setActivePage: (page: string) => void;
}

const PageMenu = ({ setActivePage }: PageMenuProps) => {
  const menuItems = [
    {
      title: 'Übersicht',
      id: 'overview',
      onClick: () => setActivePage('overview')
    },
    {
      title: 'Positionen',
      id: 'positionen',
      onClick: () => setActivePage('positions')
    },
    {
      title: 'Kundenansicht',
      id: 'customer',
      onClick: () => setActivePage('customer')
    }
  ];

  return <NavbarMenu items={menuItems} />;
};

export { PageMenu };
